// sessionStorage key set just before the page reloads for a new service worker
// (index.js) and read once on the next load to toast the user (App.js).
export const SW_UPDATED_FLAG = 'zelp_sw_updated';

// Reads the marker and clears it, so the toast is shown exactly once per update.
export const consumeServiceWorkerUpdatedFlag = () => {
    try {
        if (sessionStorage.getItem(SW_UPDATED_FLAG) !== '1') return false;
        sessionStorage.removeItem(SW_UPDATED_FLAG);
        return true;
    } catch (err) {
        // sessionStorage can throw in private / storage-blocked contexts.
        return false;
    }
};
